export enum GoogleAddressCompTypesEnum {
    street_number="street_number",
    route="route",
    locality ="locality",
    administrative_area_level_1 ="administrative_area_level_1",
    country ="country",
    postal_code ="postal_code",
    premise  ="premise",
    subpremise ="subpremise",
    postal_code_suffix ="postal_code_suffix",

}
